import { render } from "./Modal.vue?vue&type=template&id=23b5527d&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=23b5527d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23b5527d"

export default script